<div
  *ngIf="(hoverBoxEnabled || showAlways) && (toolTipToggleVisible$ | async)"
  #hoverboxEl
  class="hoverbox"
  [style.left.px]="positionCoords.x"
  [style.top.px]="positionCoords.y"
  data-e2e="tooltip-fragment"
>
  <p class="hoverbox-text" data-e2e="tooltip-fragment__tooltip-text">
    <ng-content></ng-content>
  </p>
</div>
